import { Component, Input, OnInit, Renderer2 } from '@angular/core';
import { CommonDropdownModel } from '../../../../../crm/companies/pop-ups/add-company/add-company.model';
import { CommonTabService } from './../../../../../../shared/services/common-tab.service';
import { FilterCheckList } from '../../../../../crm/companies/pages/companies/companies.model';
import { WindowSizeService } from '../../../../../../shared/services/window-resize.service';
import { Categories, LabelsName } from '../../../../../../shared/model/enum';
import { PartsListService } from '../../../pages/parts-list/parts-list.service';

@Component({
  selector: 'app-compliance-export',
  templateUrl: './compliance-export.component.html',
  styleUrls: ['./compliance-export.component.scss']
})
export class ComplianceExportComponent implements OnInit {
  @Input() formModel:any ={}
  @Input() getAllDropdown:any ={}
  @Input() filterCheckList = new FilterCheckList();
  enumFilterLabel = LabelsName;
  constructor(public renderer: Renderer2, public commonTabService: CommonTabService,
    public partsListService: PartsListService,
  ) { }

  ngOnInit(): void {
    this.formModel.complianceExportModel = this.formModel?.complianceExportModel ?? {};
    this.fillCheckedList()
  }
  fillCheckedList() {
    this.filterCheckList.rohs_CheckList = this.formModel?.complianceExportModel?.rohsId?.map((value) => value.name);
    this.filterCheckList.coo_CheckList = this.formModel?.complianceExportModel?.cooId?.map((value) => value.name);
    const tagIds = this.formModel?.complianceExportModel?.tagId?.map(tag => tag?.id)??[];
    this.getAllDropdown?.partTagsList?.forEach(x => x.selectedTags = tagIds?.includes(x.id));
  }
  // for input keydown ------------------
  onKeydown(event: any, value: any) {
    const element = this.renderer.selectRootElement(value, true);
    if (event.key === "Enter") {
      element.focus();
    }
  }
  clearDetails() {
    this.getAllDropdown?.partTagsList?.forEach((x) => (x.selectedTags = false));
    this.formModel.complianceExportModel.tagId = [];
  }
  tagsId:any = [];
  selectAccountTagsId(item, index) {
    this.formModel.complianceExportModel.tagId ??= [];
    
    if (this.formModel?.complianceExportModel?.tagId?.length) {
      this.tagsId = this.formModel.complianceExportModel.tagId.map(x => x.id);
    }
    const tagIndex = this.tagsId.indexOf(item.id);
    tagIndex !== -1 
        ? this.tagsId.splice(tagIndex, 1) 
        : this.tagsId.push(item.id);

    this.getAllDropdown?.partTagsList?.forEach(x => x.selectedTags = this.tagsId.includes(x.id));
    this.formModel.complianceExportModel.tagId = this.getAllDropdown?.partTagsList?.filter((a) => a?.selectedTags === true) ?? [];
}
inputValueEmit(event){
  if (!this.getAllDropdown?.roHSList) {
    return;
  }
  this.getAllDropdown.roHSList = this.getAllDropdown.roHSList.map(item => {
    if (item.id === event.id) {
      return { ...item, isActive: event.isActive };
    }
    return item;
  });
  let rohsId =this.getAllDropdown?.roHSList?.filter((a) => a?.isActive === true) ??[];
  this.formModel.complianceExportModel = this.formModel?.complianceExportModel??{}
  this.formModel.complianceExportModel.rohsId = rohsId;
}
inputValueCOOEmit(event){
  if (!this.getAllDropdown?.countryList) {
    return;
  }
  this.getAllDropdown.countryList = this.getAllDropdown.countryList.map(item => {
    if (item.id === event.id) {
      return { ...item, isActive: event.isActive };
    }
    return item;
  });
  let cooId  =this.getAllDropdown?.countryList?.filter((a) => a?.isActive === true) ??[];
  this.formModel.complianceExportModel.cooId = cooId;
}
onChangedValue(event, label) {
  if (event === '') {
    this.clearFields(label, event);
  }  else if (event) {
    this.clearFields(label, '');
    this.fetchById(label, event);
  }
}

clearFields(label, value) {
  const model = this.formModel?.complianceExportModel;
  switch (label) {
    case this.enumFilterLabel?.CATEGORY_GROUP:
      model.parentCategoryId = model.categoryId = model.subCategoryId = value;
      break;
    case this.enumFilterLabel?.PARENT_CATEGORY:
      model.categoryId = model.subCategoryId = value;
      break;
    case this.enumFilterLabel?.CATEGORY:
      model.subCategoryId = value;
      break;
  }
}

fetchById(label, event) {
  const ids = {
    [this.enumFilterLabel?.CATEGORY_GROUP]: Categories?.CATEGORY_GROUPID,
    [this.enumFilterLabel?.PARENT_CATEGORY]: Categories?.PARENT_CATEGORY_GROUPID,
    [this.enumFilterLabel?.CATEGORY]: Categories?.CATEGORY_ID,
  };
  this.getById(ids[label], event, label);
}
getById(request,id,label) {
  this.partsListService.getInventoryCategoryDropdownById(request,id).subscribe((res) => {
    if (res) {
      switch (label) {
        case this.enumFilterLabel?.CATEGORY_GROUP:
          this.getAllDropdown.parentCategoryGroupList = res?.response?.list
          break
        case this.enumFilterLabel?.PARENT_CATEGORY:
          this.getAllDropdown.inventoryCategoryList = res?.response?.list
          break
        case this.enumFilterLabel?.CATEGORY:
          this.getAllDropdown.subCategoryList = res?.response?.list
          break
      }
    }
  })
}

}
 